<app-aw-modal data-testid="quick-payout-modal">
    <h4 modal-title>
        {{ "overview.payout_now" | translate }}
    </h4>
    <ng-container modal-body>
        <p>{{ "overview.payout_now_description" | translate }}</p>
        <br />
        <div class="label-tooltip-box">
            <p>{{ "overview.select_bank_account" | translate }}</p>
            <app-aw-tooltip [tooltipTitle]="'overview.select_bank_account' | translate">
                <span description>{{ "overview.only_possible_to_pay_out_one_account_at_a_time" | translate }}</span>
            </app-aw-tooltip>
        </div>
        <ng-select [items]="availableFunds()" [(ngModel)]="selectedBankAccount" (change)="onSelectionChange()" [placeholder]="'overview.select_bank_account' | translate" data-testid="quick-payout-modal-bank-account-select">
            <ng-template ng-label-tmp let-item="item">
                {{ formatForSelectBox(item) }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
                {{ formatForSelectBox(item) }}
            </ng-template>
        </ng-select>
        <br />
        <div class="label-with-sum">
            <p>{{ "overview.payout_now_label_1" | translate }}</p>
            <p style="font-weight: 600">{{ formatAmount() }}</p>
        </div>

        <div class="aw-hr"></div>

        <div class="label-with-sum">
            <div style="display: flex; flex-direction: row; gap: 5px">
                <p>{{ "overview.payout_now_label_2" | translate }}</p>
                <app-aw-tooltip [tooltipTitle]="'overview.price' | translate">
                    <ng-container description>
                        {{ structuredLabel }}
                    </ng-container>
                </app-aw-tooltip>
            </div>
            <p style="font-weight: 600">{{ formatPrice() }}</p>
        </div>

        @if (initLoading) {
            <br />
            <app-loading-indicator [size]="'small'" [color]="'secondary'"></app-loading-indicator>
            <br />
        } @else {
            <div class="aw-hr"></div>
            <div class="label-with-sum" style="padding-top: 12px">
                <p style="font-weight: 600">{{ "overview.instant_payout_label_3" | translate }}</p>
                <p style="font-weight: 600">{{ formatPayoutResult() }}</p>
            </div>

            <div class="aw-hr"></div>
        }
    </ng-container>
    <ng-container modal-footer>
        <app-aw-button [disabled]="confirmBtnDisabled()" [loading]="loading()" (clickEmitter)="confirmQuickPayout()" size="large" [dataTestId]="'quick-payout-modal-confirm-button'">
            <span button-content>{{ (selectedBankAccount()?.processing_payout ? "overview.payout_in_process" : "overview.payout_confirm") | translate }}</span>
        </app-aw-button>
        @if (fireCustomer()?.payout_settings?.interval !== "weekly") {
            <div style="margin-top: 16px">
                <app-aw-button [routerLink]="'/account'" color="primary-outlined" size="large" [dataTestId]="'quick-payout-modal-weekly-payout-button'">
                    <span [routerLink]="'/account'" button-content>{{ "overview.or_weekly_payout" | translate }} <img src="assets/icons/arrow-right-green.svg" alt="arrow right" /></span>
                </app-aw-button>
            </div>
        }
    </ng-container>
</app-aw-modal>
